import styled from 'styled-components'

export const Container = styled.div`
  ul {
    padding: 0;
    margin: 4px 0 0;
    list-style: none;
    display: flex;

    li {
      &:not(:last-child) {
        margin-right: 15px;
      }

      svg {
        width: 22px;
        height: 22px;
      }

      a {
        transition: opacity ease-in-out 0.3s;

        &:hover {
          svg {
            opacity: 0.6;
          }
        }
      }

      .icon {
        &-facebook {
          svg {
            fill: ${props => props.theme.palette.general.blueDark};
          }
        }

        &-pinterest {
          svg {
            fill: ${props => props.theme.palette.general.red};
          }
        }

        &-twitter {
          svg {
            fill: ${props => props.theme.palette.general.blueLight};
          }
        }
      }
    }
  }
`
